const AUTH_REVOKED_CLOSE_CODES = new Set([4401, 4403]);
const MAX_RETRY_WAIT_MS = 5_000;

const getCloseCode = (eventOrError) => Number(eventOrError?.code);

const shouldRetryWebSocket = (eventOrError, expectedClusterSwitch = false) => {
  const code = getCloseCode(eventOrError);

  // Cluster switching intentionally closes the old socket with 4403. The
  // expected-switch flag allows graphql-ws to establish a new socket with the
  // new cluster snapshot, while ordinary authorization failures stay closed.
  if (code === 4403 && expectedClusterSwitch) return true;
  return !AUTH_REVOKED_CLOSE_CODES.has(code);
};

const isAuthRevokedClose = (eventOrError) => (
  AUTH_REVOKED_CLOSE_CODES.has(getCloseCode(eventOrError))
);

const retryWait = async (retries) => {
  const exponentialDelay = 1_000 * (2 ** Math.min(Number(retries) || 0, 3));
  const jitter = Math.floor(Math.random() * 1_000);
  await new Promise((resolve) => setTimeout(
    resolve,
    Math.min(exponentialDelay + jitter, MAX_RETRY_WAIT_MS),
  ));
};

export {
  AUTH_REVOKED_CLOSE_CODES,
  isAuthRevokedClose,
  MAX_RETRY_WAIT_MS,
  retryWait,
  shouldRetryWebSocket,
};
